<template>
  <div v-loading="loading">
    <button
      @click="handleExec()"
      class="btn btn-danger btn-fill btn-wd"
      title="Avalia os documentos verificando se há algum duplicado e remove-os do sistema">
      Remover lâmpadas duplicadas
    </button>
    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>

<script>
import Couchdb from '../services/Couchdb'

export default {
  name: 'remove-duplicated-lamps',

  data () {
    return {
      lamps: {},
      originalLamps: [],
      lampsByCustomerId: {},
      idToRemoved: [],
      loading: false,
      progressPercentage: 0,
      fullLamps: []
    }
  },

  computed: {
    countLamps () {
      return Object.keys(this.lamps).length
    },

    events: {
      get () {
        return this.$store.state.events.all.reduce((acc, curr, indx) => {
          if (indx === 0) {
            acc = {}
          }
          let id = curr._id
          acc[id] = `${curr.reference}_${curr.place}}`
          return acc
        }, {})
      }
    },

    countOriginalLamps () {
      return Object.keys(this.originalLamps).length
    },

    countLampsItemsToRemove () {
      return this.idToRemoved.map(item => {
        return this.originalLamps[item]
      }).reduce((acc, curr, indx) => {
        acc = indx === 0 ? 0 : acc
        return acc + curr.items.length
      }, 0)
    },

    config: {
      get () {
        return this.$store.state.config
      }
    }
  },

  methods: {
    handleExec () {
      this.loading = true
      this.resetValues()
      this.fetchLamps()
    },

    fetchLamps () {
      Couchdb.connection('default')
        .view('lamps-by-createdAt', 'lamps-by-createdAt')
        .then(response => this.verify(response))
        .catch(err => this.handleError(err))
        .finally(() => {
          this.loading = false
        })
    },

    async verify (response) {
      await this.filterLamps(response)
      this.verifyLamps()
    },

    filterLamps (response) {
      return new Promise((resolve) => {
        resolve(this.filterLampsTwoMoreExchanges(
          this.getObjectLamps(
            response.rows.map(item => {
              return item.value
            })
          )
        ))
      })
    },

    filterLampsTwoMoreExchanges (lampsObj) {
      for (let id in lampsObj) {
        if (lampsObj[id].length > 1) {
          this.lamps[id] = lampsObj[id]
        }
      }
    },

    getObjectLamps (lamps) {
      this.setOriginalLampsById(lamps)
      return lamps.reduce((acc, curr, indx) => {
        if (indx === 0) {
          acc = {}
        }
        let customerId = curr.customer.id
        curr.createdAt = this.$moment(curr.createdAt).format('YYYY/MM/DD hh:mm:ss')
        if (!acc.hasOwnProperty(customerId)) {
          acc[customerId] = [curr]
        } else {
          acc[customerId].push(curr)
        }
        return acc
      }, {})
    },

    setOriginalLampsById (lamps) {
      this.originalLamps = lamps.reduce((acc, curr, indx) => {
        if (indx === 0) {
          acc = {}
        }
        let customerId = curr.customer.id
        if (!acc.hasOwnProperty(customerId)) {
          acc[curr._id] = curr
        }
        return acc
      }, {})
    },

    verifyLamps () {
      for (let id in this.lamps) {
        this.verifySame(this.lamps[id])
      }
    },

    verifySame (lamps) {
      let same = Object.assign({}, {})
      for (let lamp of lamps) {
        same = Object.assign({}, same)
        if (this.compareData(lamp, same)) {
          if (!same.hasOwnProperty(lamp._id)) {
            same[lamp._id] = {id: lamp.customer.id, uc: lamp.customer.uc, date: lamp.createdAt, event: lamp.eventId}
          }
        }
      }
    },

    compareData (lamp, same) {
      for (let key in same) {
        if (this.compareVerifyData(same[key], lamp)) {
          this.addIdToRemove(lamp._id)
          return false
        }
      }
      return true
    },

    compareVerifyData (compare, lamp) {
      return lamp.customer.uc === compare.uc &&
        lamp.createdAt === compare.date
    },

    addIdToRemove (id) {
      if (this.idToRemoved.indexOf(id) === -1) {
        this.idToRemoved.push(id)
        // if (['8312127', '2430236', '1414124', '8452039', '1414124', '8028489', '8076220', '10925', '1095912', '1380989', '3201914', '3161686', '7671399', '1035032', '2652236', '716632', '1650439', '2397494', '2620565', '4036209', '4036209', '8717596', '76324', '4104438', '5087159', '7670849', '4645273', '3217778', '4637876', '9101254', '7687059', '4648516', '5021814', '5529152', '6777056'].indexOf(this.originalLamps[id].customer.uc) === -1) {
          // console.log(this.originalLamps[id].customer.uc)
        console.log(`idLampada,${this.originalLamps[id]._id},quantidade-lamapdas,${this.originalLamps[id].items.length},data-troca,${this.originalLamps[id].createdAt},uc-cliente,${this.originalLamps[id].customer.uc},id-cliente,${this.originalLamps[id].customer.id},event-id,${this.originalLamps[id].eventId},event,${this.events[this.originalLamps[id].eventId]}`)
        // }
      }
    },

    handleError (err) {
      console.log('error', err)
    },

    resetValues () {
      this.idToRemoved = []
      this.lamps = {}
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/commands/RemoveDuplicatedLamps.vue